<template>
  <div class="log-in-component">
    <div class="log-in-btn" @mouseenter.stop="handleHover" @mouseleave.stop="handleLeave">
      <img v-if="isLogin && avatar" :src="avatar" class="avatar" @click.stop="handleClickSpace" />
      <span v-else @click="handleLogIn">登录</span>
    </div>

    <div v-show="!hiddenPopover || hoverPopover" class="panel-popover" @mouseenter.stop="handleHoverPopover" @mouseleave.stop="handleLeavePopover">
      <div v-if="isLogin" class="logout-panel-popover">
        <div class="logout-item" @click="handleLogOut">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="link-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6137 9.30115C17.6932 9.10837 17.6932 8.89282 17.6137 8.70004C17.5743 8.60393 17.5165 8.51726 17.4443 8.44504L15.2221 6.22282C14.9148 5.9156 14.4176 5.91615 14.111 6.22282C13.8043 6.52948 13.8037 7.02671 14.111 7.33393L14.9921 8.21504L7.99985 8.21504C7.56596 8.21448 7.21429 8.56615 7.21429 9.00059C7.21429 9.21726 7.30207 9.41393 7.44429 9.55615C7.58651 9.69837 7.78318 9.78615 7.99985 9.78615L14.9921 9.78615L14.111 10.6673C13.8043 10.9739 13.8037 11.4712 14.111 11.7784C14.4182 12.0856 14.9154 12.085 15.2221 11.7784L17.4443 9.55615C17.5165 9.48393 17.5743 9.39726 17.6137 9.30115" fill="#61666d"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.8889 5.11111C9.74127 2.96349 6.25873 2.96349 4.11111 5.11111C1.96349 7.25873 1.96349 10.7413 4.11111 12.8889C6.25873 15.0365 9.74127 15.0365 11.8889 12.8889C12.1957 12.5821 12.6932 12.5821 13 12.8889C13.3068 13.1957 13.3068 13.6932 13 14C10.2387 16.7613 5.76127 16.7613 3 14C0.238731 11.2387 0.23873 6.76127 3 4C5.76127 1.23873 10.2387 1.23873 13 4C13.3068 4.30683 13.3068 4.80429 13 5.11111C12.6932 5.41794 12.1957 5.41794 11.8889 5.11111Z" fill="#61666d"></path></svg>
          <span>退出登录</span>
        </div>
      </div>
      <div v-else class="login-panel-popover">
        <p class="popover-title">登录后你可以：</p>
        <div class="login-tip-content">
          <div class="login-tip-content-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="#00aeec"
            >
              <path
                d="M12 4.99805C9.48178 4.99805 7.283 5.12616 5.73089 5.25202C4.65221 5.33949 3.81611 6.16352 3.72 7.23254C3.60607 8.4998 3.5 10.171 3.5 11.998C3.5 13.8251 3.60607 15.4963 3.72 16.76355C3.81611 17.83255 4.65221 18.6566 5.73089 18.7441C7.283 18.8699 9.48178 18.998 12 18.998C14.5185 18.998 16.7174 18.8699 18.2696 18.74405C19.3481 18.65655 20.184 17.8328 20.2801 16.76405C20.394 15.4973 20.5 13.82645 20.5 11.998C20.5 10.16965 20.394 8.49877 20.2801 7.23205C20.184 6.1633 19.3481 5.33952 18.2696 5.25205C16.7174 5.12618 14.5185 4.99805 12 4.99805zM5.60965 3.75693C7.19232 3.62859 9.43258 3.49805 12 3.49805C14.5677 3.49805 16.8081 3.62861 18.3908 3.75696C20.1881 3.90272 21.6118 5.29278 21.7741 7.09773C21.8909 8.3969 22 10.11405 22 11.998C22 13.88205 21.8909 15.5992 21.7741 16.8984C21.6118 18.7033 20.1881 20.09335 18.3908 20.23915C16.8081 20.3675 14.5677 20.498 12 20.498C9.43258 20.498 7.19232 20.3675 5.60965 20.2392C3.81206 20.0934 2.38831 18.70295 2.22603 16.8979C2.10918 15.5982 2 13.8808 2 11.998C2 10.1153 2.10918 8.39787 2.22603 7.09823C2.38831 5.29312 3.81206 3.90269 5.60965 3.75693z"
                fill=""
              ></path>
              <path
                d="M6.85626 8.28906C7.27047 8.28906 7.60626 8.62485 7.60626 9.03906L7.60626 11.25L10.43895 11.25L10.43895 9.03906C10.43895 8.62485 10.7747 8.28906 11.18895 8.28906C11.6031 8.28906 11.93895 8.62485 11.93895 9.03906L11.93895 14.96095C11.93895 15.37515 11.6031 15.71095 11.18895 15.71095C10.7747 15.71095 10.43895 15.37515 10.43895 14.96095L10.43895 12.75L7.60626 12.75L7.60626 14.96095C7.60626 15.37515 7.27047 15.71095 6.85626 15.71095C6.44205 15.71095 6.10626 15.37515 6.10626 14.96095L6.10626 9.03906C6.10626 8.62485 6.44205 8.28906 6.85626 8.28906z"
                fill=""
              ></path>
              <path
                d="M14.5492 9.80269L14.5492 14.19735C15.1834 14.17465 15.76965 14.1047 16.2202 13.87005C16.47645 13.7365 16.6803 13.55365 16.82725 13.28815C16.97795 13.016 17.09375 12.6113 17.09375 12C17.09375 11.38875 16.97795 10.98405 16.82725 10.7119C16.6803 10.4464 16.47645 10.26359 16.2202 10.12998C15.76965 9.89535 15.1834 9.8254 14.5492 9.80269zM13.0492 9.28909C13.0492 8.73971 13.4943 8.28713 14.05195 8.28944C14.86295 8.29268 15.99115 8.31782 16.9166 8.80148C17.4017 9.05504 17.83555 9.43502 18.1409 9.98772C18.4426 10.5338 18.59375 11.20265 18.59375 12C18.59375 12.79745 18.4426 13.46625 18.1409 14.01235C17.83555 14.565 17.4017 14.945 16.9166 15.1986C15.99115 15.6822 14.86295 15.70735 14.05195 15.7106C13.4943 15.7129 13.0492 15.26035 13.0492 14.71095L13.0492 9.28909z"
                fill=""
              ></path></svg
            ><span class="lt-text">免费看高清视频</span>
          </div>
          <div class="login-tip-content-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="#00aeec"
            >
              <path
                d="M12 7.23438C12.4142 7.23438 12.75 7.57017 12.75 7.98438L12.75 11.68935L15.40535 14.34465C15.6982 14.63755 15.6982 15.11245 15.40535 15.40535C15.11245 15.6982 14.63755 15.6982 14.34465 15.40535L11.46965 12.53035C11.32905 12.3897 11.25 12.1989 11.25 12L11.25 7.98438C11.25 7.57017 11.5858 7.23438 12 7.23438z"
                fill=""
              ></path>
              <path
                d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5zM2 12C2 6.47715 6.47715 2 12 2C17.52285 2 22 6.47715 22 12C22 17.52285 17.52285 22 12 22C6.47715 22 2 17.52285 2 12z"
                fill=""
              ></path></svg
            ><span class="lt-text">多端同步播放记录</span>
          </div>
          <div class="login-tip-content-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="#00aeec"
            >
              <path
                d="M12 4.99805C9.48178 4.99805 7.283 5.12616 5.73089 5.25202C4.65221 5.33949 3.81611 6.16352 3.72 7.23254C3.60607 8.4998 3.5 10.171 3.5 11.998C3.5 13.8251 3.60607 15.4963 3.72 16.76355C3.81611 17.83255 4.65221 18.6566 5.73089 18.7441C7.283 18.8699 9.48178 18.998 12 18.998C14.5185 18.998 16.7174 18.8699 18.2696 18.74405C19.3481 18.65655 20.184 17.8328 20.2801 16.76405C20.394 15.4973 20.5 13.82645 20.5 11.998C20.5 10.16965 20.394 8.49877 20.2801 7.23205C20.184 6.1633 19.3481 5.33952 18.2696 5.25205C16.7174 5.12618 14.5185 4.99805 12 4.99805zM5.60965 3.75693C7.19232 3.62859 9.43258 3.49805 12 3.49805C14.5677 3.49805 16.8081 3.62861 18.3908 3.75696C20.1881 3.90272 21.6118 5.29278 21.7741 7.09773C21.8909 8.3969 22 10.11405 22 11.998C22 13.88205 21.8909 15.5992 21.7741 16.8984C21.6118 18.7033 20.1881 20.09335 18.3908 20.23915C16.8081 20.3675 14.5677 20.498 12 20.498C9.43258 20.498 7.19232 20.3675 5.60965 20.2392C3.81206 20.0934 2.38831 18.70295 2.22603 16.8979C2.10918 15.5982 2 13.8808 2 11.998C2 10.1153 2.10918 8.39787 2.22603 7.09823C2.38831 5.29312 3.81206 3.90269 5.60965 3.75693z"
                fill=""
              ></path>
              <path
                d="M15.875 9.25L9.875 9.25C9.46079 9.25 9.125 8.91421 9.125 8.5C9.125 8.08579 9.46079 7.75 9.875 7.75L15.875 7.75C16.2892 7.75 16.625 8.08579 16.625 8.5C16.625 8.91421 16.2892 9.25 15.875 9.25z"
                fill=""
              ></path>
              <path
                d="M17.375 12.75L11.375 12.75C10.9608 12.75 10.625 12.4142 10.625 12C10.625 11.5858 10.9608 11.25 11.375 11.25L17.375 11.25C17.7892 11.25 18.125 11.5858 18.125 12C18.125 12.4142 17.7892 12.75 17.375 12.75z"
                fill=""
              ></path>
              <path
                d="M7.875 8.5C7.875 8.91421 7.53921 9.25 7.125 9.25L6.625 9.25C6.21079 9.25 5.875 8.91421 5.875 8.5C5.875 8.08579 6.21079 7.75 6.625 7.75L7.125 7.75C7.53921 7.75 7.875 8.08579 7.875 8.5z"
                fill=""
              ></path>
              <path
                d="M9.375 12C9.375 12.4142 9.03921 12.75 8.625 12.75L8.125 12.75C7.71079 12.75 7.375 12.4142 7.375 12C7.375 11.5858 7.71079 11.25 8.125 11.25L8.625 11.25C9.03921 11.25 9.375 11.5858 9.375 12z"
                fill=""
              ></path></svg
            ><span class="lt-text">发表弹幕/评论</span>
          </div>
          <div class="login-tip-content-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="#00aeec"
            >
              <path
                d="M12 4.99805C9.48178 4.99805 7.283 5.12616 5.73089 5.25202C4.65221 5.33949 3.81611 6.16352 3.72 7.23254C3.60607 8.4998 3.5 10.171 3.5 11.998C3.5 13.8251 3.60607 15.4963 3.72 16.76355C3.81611 17.83255 4.65221 18.6566 5.73089 18.7441C7.283 18.8699 9.48178 18.998 12 18.998C14.5185 18.998 16.7174 18.8699 18.2696 18.74405C19.3481 18.65655 20.184 17.8328 20.2801 16.76405C20.394 15.4973 20.5 13.82645 20.5 11.998C20.5 10.16965 20.394 8.49877 20.2801 7.23205C20.184 6.1633 19.3481 5.33952 18.2696 5.25205C16.7174 5.12618 14.5185 4.99805 12 4.99805zM5.60965 3.75693C7.19232 3.62859 9.43258 3.49805 12 3.49805C14.5677 3.49805 16.8081 3.62861 18.3908 3.75696C20.1881 3.90272 21.6118 5.29278 21.7741 7.09773C21.8909 8.3969 22 10.11405 22 11.998C22 13.88205 21.8909 15.5992 21.7741 16.8984C21.6118 18.7033 20.1881 20.09335 18.3908 20.23915C16.8081 20.3675 14.5677 20.498 12 20.498C9.43258 20.498 7.19232 20.3675 5.60965 20.2392C3.81206 20.0934 2.38831 18.70295 2.22603 16.8979C2.10918 15.5982 2 13.8808 2 11.998C2 10.1153 2.10918 8.39787 2.22603 7.09823C2.38831 5.29312 3.81206 3.90269 5.60965 3.75693z"
                fill=""
              ></path>
              <path
                d="M14.7138 10.96875C15.50765 11.4271 15.50765 12.573 14.71375 13.0313L11.5362 14.8659C10.74235 15.3242 9.75 14.7513 9.75001 13.8346L9.75001 10.1655C9.75001 9.24881 10.74235 8.67587 11.5362 9.13422L14.7138 10.96875z"
                fill=""
              ></path></svg><span class="lt-text">热门番剧影视看不停</span>
          </div>
        </div>
        <div class="login-btn" @click="handleLogIn">立即登录</div>
        <div class="register-tip">
          首次使用？ <span class="register-exper"> 点我注册 </span>
        </div>
        </div>
    </div>
  </div>
</template>
<script>
import { loadScript } from "../utils";
import { logOut } from '../api';
export default {
  props: {
    isLogin: Boolean,
    avatar: String,
  },
  data() {
    return {
      loginModalJs:
        "https://s1.hdslb.com/bfs/seed/jinkela/short/mini-login-v2/miniLogin.umd.min.js",
      hiddenPopover: true,
      hiddenPopoverTimeoutId: null,
      hoverPopover: false,
      hoverPopoverTimeout: null,
    };
  },

  methods: {
    handleClickSpace() {
      window.open('https://space.bilibili.com', '_blank')
    },

    handleLogIn() {
      // cb  // todo 缓存
      loadScript(this.loginModalJs)
        .then(() => {
          const miniLogin = new window.MiniLogin({
            origin: "digiworks-pc",
          });
          // 显示登录组件
          miniLogin.showComponent({
            // spm_id_from: from,
          });
          // 监听用户关闭迷你登录框事件
          miniLogin.addEventListener("show", () => {
            console.log("show---mini-login"); // 展示
          });
          miniLogin.addEventListener("success", (data) => {
            this.$emit('success', data)
          });
          miniLogin.addEventListener("cancel", (data) => {
            // reject(data)
            this.$emit('cancel', data)
          });
        })
        .catch(() => {});
    },

    handleLogOut() {
      logOut().then((res) => {
        console.log('logout  res ', res)
        if (+res.code === 0) {
          console.log('登出成功')
        } else {
          this.$toast.info('登出失败')
        }
      }).catch(() => {
        this.$toast.info('登出失败')
      }).finally(() => {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
    },

    handleHover() {
      if (this.hiddenPopoverTimeoutId) {
        clearTimeout(this.hiddenPopoverTimeoutId)
      }
      this.hiddenPopover = false;
    },

    handleLeave() {
      this.hiddenPopoverTimeoutId = setTimeout(() => {
        this.hiddenPopover = true;
      }, 500)
    },

    handleHoverPopover() {
      if (this.hoverPopoverTimeout) {
        clearTimeout(this.hoverPopoverTimeout)
      }
      this.hoverPopover = true
    },

    handleLeavePopover() {
      this.hoverPopoverTimeout = setTimeout(() => {
        this.hoverPopover = false
      }, 500)
    }
  },
};
</script>
<style scoped>
.log-in-component {
  position: relative;
  z-index: 99;
  transition: visible 0.3s ease-in-out;
}
.log-in-btn {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  background: #00aeec;
  text-align: center;
  letter-spacing: 0;
  font-size: 14px;
  line-height: 40px;
}

.panel-popover {
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  background-color: transparent;
  color: #18191c;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  top: 36px;
  right: 10px;
  padding-top: 16px;
  text-align: left;
  width: auto;
  overflow: hidden;
}

.login-panel-popover {
  border: 1px solid #e3e5e7;
  width: 359px;
  border-radius: 8px;
  padding: 16px 20px 22px 20px;
  background-color: #fff;
}

.logout-panel-popover {
  width: 204px;
  border: 1px solid #e3e5e7;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 20px 10px 20px;
}

.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.popover-title {
  margin-top: 4px;
  margin-bottom: 15px;
  color: #18191c;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
}

.login-tip-content {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}

.login-tip-content-item {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  width: 50%;
  height: 26px;
}

.login-btn {
  position: relative;
  display: block;
  box-sizing: border-box;
  height: 40px;
  border-radius: 8px;
  color: #fff;
  background: #00aeec;
  text-align: center;
  letter-spacing: 0;
  font-size: 16px;
  line-height: 40px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.register-tip {
  margin-top: 16px;
  color: #18191c;
  text-align: center;
  letter-spacing: 0;
  font-size: 14px;
  line-height: 20px;
}

.logout-item {
  display: flex;
    align-items: center;
    padding: 10px 14px;
    border-radius: 8px;
    color: #61666d;
    font-size: 14px;
    cursor: pointer;
    transition: background-color .3s;
}
</style>
